import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { VisitBookingReason } from "@app/models/rest/visit-booking-reason";

@Injectable({
  providedIn: "root"
})
export class VisitBookingReasonRestService extends HateoasResourceOperation<VisitBookingReason> {
  constructor() {
    super(VisitBookingReason);
  }
}
